import identity from "lodash/fp/identity";
class CaptainInvoicePageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default CaptainInvoicePageTransform;



// WEBPACK FOOTER //
// ./src/pages/captainInvoice/captainInvoice.transforms.js